import { FC } from 'react'
import { DatePicker } from 'antd'
import type { Dayjs } from 'dayjs'
import { CheckBoxLabel } from '@UI/CheckBox'
import classes from './purchase.module.css'

interface IDemoPeriodFields {
  enabled: boolean
  startDate: Dayjs | null
  endDate: Dayjs | null
  onToggle: () => void
  onStartDateChange: (date: Dayjs | null) => void
  onEndDateChange: (date: Dayjs | null) => void
}

const DemoPeriodFields: FC<IDemoPeriodFields> = ({
  enabled,
  startDate,
  endDate,
  onToggle,
  onStartDateChange,
  onEndDateChange,
}) => (
  <div className={classes.demoPeriodBox}>
    <CheckBoxLabel
      value={enabled}
      onClick={onToggle}
      label="Добавить демо-период"
      style={{ justifyContent: 'flex-start' }}
    />
    {enabled && (
      <>
        <div className={classes.demoPeriodHint}>
          Оплата не создаётся. После окончания демо отметка останется до первой
          оплаты.
        </div>
        <div className={classes.dateSelectionRow}>
          <DatePicker
            value={startDate}
            onChange={onStartDateChange}
            format="YYYY.MM.DD"
            placeholder="Начало демо"
            className={classes.datePicker}
          />
          <DatePicker
            value={endDate}
            onChange={onEndDateChange}
            format="YYYY.MM.DD"
            placeholder="Окончание демо"
            className={classes.datePicker}
            disabledDate={(date) =>
              Boolean(startDate && date.isBefore(startDate, 'day'))
            }
          />
        </div>
      </>
    )}
  </div>
)

export default DemoPeriodFields
